<template id="new-visita">
  <v-dialog v-model="show" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Datos de Proveedor</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="RBD"
                name="rbd"
                v-model="rbd"
                required
              ></v-text-field>
              <v-text-field
                label="Rut"
                name="rut"
                v-model="rut"
                required
              ></v-text-field>
              <v-text-field
                label="Razon Social"
                name="razonSocial"
                v-model="razonSocial"
                required
              ></v-text-field>
              <v-text-field
                label="Contacto"
                name="contacto"
                v-model="contacto"
                required
              ></v-text-field>
              <v-text-field
                label="Fono"
                name="fono"
                v-model="fono"
                required
              ></v-text-field>
              <v-text-field
                label="Correo"
                name="correo"
                v-model="correo"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*Campos requeridos</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.prevent="modalClose()"
          >Cerrar</v-btn
        >
        <v-btn color="blue darken-1" flat @click.prevent="updateProvider(id)"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { async } from "q";
export default {
  name: "new-visita",
  props: {
    id: Number,
    dialogEdit: Boolean,
    dialogDetail: Boolean,
    tipoModal: "",
  },
  data() {
    return {
      proveedor: [],
      rbd: "",
      rut: "",
      razonSocial: "",
      contacto: "",
      fono: "",
      correo: "",
      show: Boolean,
    };
  },
  methods: {
    async loadProveedor(id) {
      let prov = [];
      try {
        return await axios.get("/proveedor/" + id).then((response) => {
          return response.data;
        });
      } catch (error) {
        console.error(error);
      }
    },
    updateProvider(id) {
      let data = {
        rut: this.rut,
        razonSocial: this.razonSocial,
        contacto: this.contacto,
        fono: this.fono,
      };
      axios({
        url: "/proveedor/" + id,
        data: data,
        method: "PUT",
      })
        .then((resp) => {})
        .catch((err) => console.log(err));
    },
    modalClose() {
      if (this.tipoModal == "edit") {
        this.$parent.dialogEdit = false;
        this.show = false;
      }
      if (this.tipoModal == "detail") {
        this.$parent.dialogDetail = false;
        this.show = false;
      }
    },
    async loadData() {
      this.proveedor = await this.loadProveedor(this.id);
      this.rbd = this.proveedor.codigo;
      this.rut = this.proveedor.rut;
      this.razonSocial = this.proveedor.razonSocial;
      this.contacto = this.proveedor.contacto;
      this.fono = this.proveedor.fono;
      this.correo = this.proveedor.correo;
    },
  },
  computed: {},
  mounted: function () {
    this.loadData();
  },
  created() {
    this.show = this.dialogEdit;
  },
};
</script>
